import {Component, OnInit} from '@angular/core';
import {EventsService} from '../../events.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-insomnia-egypt',
  templateUrl: './insomnia-egypt.component.html',
  styleUrls: ['./insomnia-egypt.component.css']
})
export class InsomniaEgyptComponent implements OnInit {
  mobileView: boolean = false;

  constructor(private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService, public globalService: GlobalService,
              private titleService:Title) {
    this.titleService.setTitle('Insomnia Clash Royale')
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {
    this.eventService.insomniaGame = this.router.url.split('/')[2];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });

  }


  getBanner(game) {
    if (game == 'home') {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/insomnia-banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/insomnia-banner.jpg';
    } else {
      if (this.mobileView)
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner-mobile.jpg';
      else
        return '../../../../assets/img/insomnia/games/' + this.eventService.insomniaGame + '/banner.jpg';
    }
  }
}
